import * as t from "./types";
import * as actions from "./action";

/* Config */
export const getConfigAction = (
  payload: t.GetConfigRequestType
): t.GetConfigActionType => {
  return {
    type: actions.GET_CONFIG,
    payload,
  };
};

export const getConfigsAction = (
  payload: t.GetConfigsRequestType
): t.GetConfigsActionType => {
  return {
    type: actions.GET_CONFIGS,
    payload,
  };
};

export const getConfigDefaultAction = (
  payload: t.GetConfigDefaultRequestType
): t.GetConfigDefaultActionType => {
  return {
    type: actions.GET_CONFIG_DEFAULT,
    payload,
  };
};

export const addConfigKeyAction = (
  payload: t.CreateConfigKeyRequestType
): t.AddConfigKeyActionType => {
  return {
    type: actions.ADD_CONFIG_KEY,
    payload,
  };
};

export const modifyConfigKeyAction = (
  payload: t.ModifyConfigKeyRequestType
): t.ModifyConfigKeyActionType => {
  return {
    type: actions.MODIFY_CONFIG_KEY,
    payload,
  };
};

export const deleteConfigKeyAction = (
  payload: t.DeleteConfigKeyRequestType
): t.DeleteConfigKeyActionType => {
  return {
    type: actions.DELETE_CONFIG_KEY,
    payload,
  };
};
